import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {EXPERT_SYSTEM_KPI_REQUEST_STALE_TIME} from '../consts'
import {
  HistoricalKpiValue,
  ExpertSystemEquipmentType,
  YearMonth,
  HistoricalMtmKpiValueQueryKey
} from '../types'

export const useHistoricalKpiMtmValue = (
  kpiTargetEquipmentType: ExpertSystemEquipmentType,
  hierarchyId: string,
  month: YearMonth,
  options?: Omit<UseQueryOptions<HistoricalKpiValue[], AxiosError>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<HistoricalKpiValue[], AxiosError>({
    queryKey: [HistoricalMtmKpiValueQueryKey, kpiTargetEquipmentType, hierarchyId, month],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<HistoricalKpiValue[]>(
        `/expert-system/kpis/${kpiTargetEquipmentType}/mtm/${hierarchyId}/${month}/history`,
        {signal}
      )
      return response.data
    },
    select: (data) => data.sort((a, b) => b.version - a.version),
    staleTime: EXPERT_SYSTEM_KPI_REQUEST_STALE_TIME,
    ...options
  })
}
